// File: ConsultingStatsVideoSection.jsx
// Pure CSS + Dummy Icons + Gradient Stats like screenshot

import { Heart, Lightbulb, Play, Presentation, Trophy } from 'lucide-react';
import React from 'react';

export default function AboutUsCard7() {
  return (<>
    <section className="cs-wrap-ac-7">
      {/* STATS SECTION */}
      <div className="cs-stats-ac-7">
        <div className="stat-item-ac-7">
          <span className="icon-ac-7"><Presentation size={30}  color={"#fff"}/></span>
          <span className="num-ac-7">1520</span>
          <span className="label-ac-7">Happy Clients</span>
        </div>
        <div className="stat-item-ac-7">
          <span className="icon-ac-7"><Heart size={30}  color={"#fff"}/></span>
          <span className="num-ac-7">65</span>
          <span className="label-ac-7">Team Members</span>
        </div>
        <div className="stat-item-ac-7">
          <span className="icon-ac-7"><Trophy size={30}  color={"#fff"}/></span>
          <span className="num-ac-7">12</span>
          <span className="label-ac-7">Awards</span>
        </div>
        <div className="stat-item-ac-7">
          <span className="icon-ac-7"><Lightbulb size={30}  color={"#fff"}/></span>
          <span className="num-ac-7">34</span>
          <span className="label-ac-7">Consulting Services</span>
        </div>
      </div>

      {/* VIDEO PRESENTATION */}
      <div className="cs-video-ac-7">
        <button className="play-btn-ac-7"><Play size={20} color={"#fff"}/></button>
        <p className="small-ac-7">YOU SHOULD KNOW MORE ABOUT US</p>
        <h2>OUR VIDEO PRESENTATION</h2>
      </div>
    </section>
    <style>{`
/* File: ConsultingStatsVideoSection.css */

:root {
  --bg-dark: #0d1420;
  --text-light: #fff;
  --fade: rgba(13, 20, 32, 0.75);
}

.cs-wrap-ac-7 {
  background: linear-gradient(var(--fade), var(--fade)), url('https://picsum.photos/1600/700?blur=2');
  background-size: cover;
  background-position: center;
  padding: 70px 40px;
  text-align: center;
  font-family: Inter, sans-serif;
  color: var(--text-light);
}

/* STATS */
.cs-stats-ac-7 {
  display: flex;
  justify-content: center;
  gap: 60px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255,255,255,0.2);
  margin-bottom: 50px;
}

.stat-item-ac-7 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.icon-ac-7 {width:90px;height:90px;border-radius:50%;display:flex;justify-content:center;align-items:center;
  background: #222222;
}

.num-ac-7 {
  font-size: 34px;
  font-weight: 800;
}

.label-ac-7 {
  font-size: 15px;
  opacity: 0.8;
}

/* VIDEO AREA */
.cs-video-ac-7 h2 {
  font-size: 32px;
  font-weight: 800;
  margin-top: 10px;
}

.small-ac-7 {
  font-size: 14px;
  opacity: 0.85;
  margin-top: 20px;
}

.play-btn-ac-7 {
  background:rgba(144, 202, 249,0.61);
  color: #fff;
  border: none;
  font-size: 32px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  cursor: pointer;
  margin-bottom: 10px;
}

/* Responsive */
@media(max-width:960px){
  .cs-stats-ac-7 {justify-content:space-between;
    flex-wrap: wrap;
    gap: 20px;
  }.stat-item-ac-7{display:flex;justify-content:center;}
  .cs-video-ac-7 h2 {
    font-size: 26px;
  }
}
`}</style>
    </>
  );
}
